'use client';

import BlogIcon from '@/assets/images/blog.svg';
import Calendar from '@/assets/images/calendar.svg';
import CoursesIcon from '@/assets/images/courses.svg';
import HomeIcon from '@/assets/images/home.svg';
import MenuIcon from '@/assets/images/menu.svg';
import { AuthModal } from '@/components/auth-modal';
import { DMButton } from '@/components/button';
import { DMImage } from '@/components/custom-image/custom-image';
import { DMLink } from '@/components/link';
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTrigger,
} from '@/components/ui/sheet';
import Menu from './menu';

type MenuType = {
  href: string;
  menuName: string;
  menuIcon?: string;
  variant: 'text' | 'primary' | 'primary_outline';
  className?: string;
  extra?: string;
};
const menus: MenuType[] = [
  {
    href: '/',
    menuName: 'Home',
    menuIcon: HomeIcon,
    variant: 'text',
    className: 'py-2',
  },
  {
    href: '/courses',
    menuName: 'Courses',
    menuIcon: CoursesIcon,
    variant: 'text',
    className: 'py-2',
  },
  {
    href: '/one-on-one',
    menuName: 'Book 1:1',
    menuIcon: Calendar,
    variant: 'text',
    className: 'py-2',
  },
  {
    href: '/blogs',
    menuName: 'Blogs',
    menuIcon: BlogIcon,
    variant: 'text',
    className: 'py-2',
  },
];

function BeforeLogin() {
  //   const [open, setOpen] = useState(true);
  return (
    <>
      <div className='flex items-center'>
        <div className='hidden md:flex  w-full items-center md:gap-10'>
          <DMLink href='/courses'>Courses</DMLink>
          <DMLink href='/one-on-one'>Mentorship</DMLink>
          <DMLink href='/blogs'>Blog</DMLink>
          <DMLink href='/achievements'>Rewards</DMLink>
          <div className='flex gap-3'>
            <AuthModal authType='login'>
              <DMButton variant='primary_outline' className='!px-7 cursor-pointer'>
                Login
              </DMButton>
            </AuthModal>
            {/* <AuthModal authType='login'>
              <DMButton variant='primary'>Join</DMButton>
            </AuthModal> */}
          </div>
        </div>
        <div className='flex md:hidden w-full items-center gap-6'>
          <DMLink href='/courses' className='text-sm'>
            Courses
          </DMLink>
          <DMLink href='/one-on-one' className='text-sm'>
            Mentorship
          </DMLink>
          <BeforeLoginHamburgerMenu />
        </div>
      </div>
    </>
  );
}

export default BeforeLogin;

const BeforeLoginHamburgerMenu = () => {
  return (
    <Sheet>
      <SheetTrigger>
        <DMImage src={MenuIcon} alt='Menu Icon' width={24} height={24} />
      </SheetTrigger>
      <SheetContent side='bottom' className='bg-brand-secondary !border-none'>
        <SheetHeader>
          <SheetDescription>
            <div className='flex flex-col text-black items-start px-3 h-auto mt-5 gap-3'>
              {menus.map((menu, index) => (
                <Menu
                  href={menu.href}
                  menuName={menu.menuName}
                  menuIcon={menu.menuIcon}
                  key={index}
                  variant={menu?.variant}
                  className={menu.className}
                  extra={menu.extra}
                />
              ))}
              <div className='flex flex-col gap-3 w-full'>
                {/* <AuthModal authType='signup'>
                  <DMButton variant='primary_outline' className='py-3'>
                    Sign up
                  </DMButton>
                </AuthModal> */}
                <AuthModal authType='login'>
                  <DMButton variant='primary' className='py-3'>
                    Login
                  </DMButton>
                </AuthModal>
              </div>
            </div>
          </SheetDescription>
        </SheetHeader>
      </SheetContent>
    </Sheet>
  );
};
